"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.THUMBNAIL_IMG = exports.PLAY_BUTTON = exports.YOUTUBE_LINK_EL = exports.THUMBNAILED_VIDEO_ROOT = void 0;
const qsOrThrowFit_1 = require("../../utils/qsOrThrowFit");
exports.THUMBNAILED_VIDEO_ROOT = (_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.closest(".thumbnailedvideo");
if (!exports.THUMBNAILED_VIDEO_ROOT)
    throw new Error("Could not find root for thumbnailed video");
const tnvQs = (qs) => (0, qsOrThrowFit_1.qsOrThrowFit)(qs, exports.THUMBNAILED_VIDEO_ROOT);
exports.YOUTUBE_LINK_EL = tnvQs(".thumbnailedvideo__link");
exports.PLAY_BUTTON = tnvQs(".thumbnailedvideo__playbutton");
exports.THUMBNAIL_IMG = tnvQs(".thumbnailedvideo__thumbnail");
